var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConversationSearchListBox"},[_c('el-input',{attrs:{"placeholder":"Wyszukaj rozmowy...","prefix-icon":"el-icon-search"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }